export default __webpack_public_path__ + "static/media/pictogramBeaconCash64.738cc92d.svg";